import CommonTable from "@/components/commonTable";
import { calibrateBsdLaserRadarRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderBasicCalibrationStatus } from "./status";

interface CalibrateTableBsdLaserRadarProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableBsdLaserRadar = (props: CalibrateTableBsdLaserRadarProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);



    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateBsdLaserRadarRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime',
            width: 180
        },
        {
            title: '参数版本号',
            dataIndex: 'version',
            width: 100
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            width: 100,
            render: renderBasicCalibrationStatus
        },
        {
            title: '车身长度',
            dataIndex: 'bodyLength',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '车身宽度',
            dataIndex: 'bodyWidth',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '后悬距离',
            dataIndex: 'rearOverhangLength',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '车身外侧到前轮外延距离',
            dataIndex: 'bodyOuterToFrontWheelOuterDist',
            width: 180,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '前悬距离',
            dataIndex: 'frontOverhangLength',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '前轮外沿距离',
            dataIndex: 'frontWheelOuterDist',
            width: 120,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '靶标中心点到前轮外延距离',
            dataIndex: 'targetCenterToFrontWheelOuterDist',
            width: 200,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '靶标中心到前轮轴水平距离',
            dataIndex: 'targetCenterToFrontAxleHorizontalDist',
            width: 200,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '标靶高度',
            dataIndex: 'targetHeight',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '雷达中心到前轮轴距离',
            dataIndex: 'radarCenterToFrontAxleDist',
            width: 180,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '雷达安装高度',
            dataIndex: 'radarMountingHeight',
            width: 120,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '雷达安装支架延申长度',
            dataIndex: 'radarBracketExtensionLength',
            width: 180,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '偏移量Dx',
            dataIndex: 'calibrationOffsetX',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '偏移量Dy',
            dataIndex: 'calibrationOffsetY',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '偏移量Dz',
            dataIndex: 'calibrationOffsetZ',
            width: 100,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R11',
            dataIndex: 'rotationMatrix11',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R12',
            dataIndex: 'rotationMatrix12',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R13',
            dataIndex: 'rotationMatrix13',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R21',
            dataIndex: 'rotationMatrix21',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R22',
            dataIndex: 'rotationMatrix22',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R23',
            dataIndex: 'rotationMatrix23',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R31',
            dataIndex: 'rotationMatrix31',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R32',
            dataIndex: 'rotationMatrix32',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: 'R33',
            dataIndex: 'rotationMatrix33',
            width: 80,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '重投影误差(pixel)',
            dataIndex: 'reprojectionError',
            width: 140,
            render: (val: number) => val?.toFixed(4)
        },
        {
            title: '标定时间',
            dataIndex: 'calibrationTime',
            width: 180
        },
        {
            title: '数据有效性',
            dataIndex: 'dataValidity',
            width: 100
        }
    ];

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: 3500, y: 400 }}
        />
    );
};

export default CalibrateTableBsdLaserRadar;
